module.exports = __webpack_public_path__ + "fonts/ec35237.woff2";